import { Component, OnInit} from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { SecurityService } from '../services/security-service';
import { UserService } from 'src/app/assabil-kernel/services/user-service';
import { BasicItem } from 'src/app/tools/models/dtos/basic-item';

@Component({
  selector: 'login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  
  public form: FormGroup;

  static LANG_RESULTS = 'LANG_RESULTS';
  static ROLE_RESULTS = 'ROLE_RESULTS';


  constructor(
    protected securityService   : SecurityService,
    public userService          : UserService,
    protected toastr            : ToastrService,
    protected router            : Router,
    protected activatedRoute    : ActivatedRoute
  ){ }
   
  ngOnInit() {

  }

  release       : string = "2.300"
  login         : string = ""; //"FCBO"; //      "00044041";
  password      : string = "";
  newPassword1  : string;
  newPassword2  : string;
  roles         : BasicItem[];
  role          : BasicItem;

  changePasswordMode : boolean = false;
  
  signIn() {
    this.changePasswordMode = false;
    
    let roleCode : string = null;
    if (this.role) roleCode = this.role.code;

    this.securityService.login(this.login, this.password, roleCode).then(roles => {

      if (roles) {
        this.toastr.info("Prière de précisier le role avec lequel vous souhaitez vous connecter");
        this.roles = roles;
        return;
      }

      if (this.userService.userInfo.token == "-1") {
        this.toastr.error("Votre mot de passe a expiré. Prière de choisir un nouveau mot de passe");
        this.changePasswordMode = true;
        return;
      }

      let nextPage =  'dashboard';
        this.router.navigate([nextPage])});
  }

  changePassword() {
    if (this.newPassword2 != this.newPassword1) {
      this.toastr.error("Votre nouveau mot de passe doit être saisi 2 fois de manière identique");
      return;
    }

    this.securityService.passwordChange(this.login, this.password, this.newPassword1).then(result => {
      this.changePasswordMode = false;
      this.toastr.success("Opération effectuée avec succès. Prière de vous connecter en utilisant votre nouveau mot de passe");
    });
  }

  getRelease(){
    return this.release;
  }

}

